<template>
  <div class="soha-emergency-level-container">
    <div
      class="soha-emergency-level-bar"
      dir="ltr"
    >
      <span
        v-for="number in 4"
        :key="number"
        :class="[number <= level ? 'active' : 'notActive']"
      />
    </div>
    <label class="secondary-color mt-3 mb-0">
      {{ $t(`${emergencyLevelTitle}`) }}
    </label>
  </div>
</template>

<script>
import "@/assets/css/components/base/emergency-level.css";
export default {
  name: "EmergencyLevel",

  props: {
    level: {
      require: true,
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      I18nPrefix: "COMPONENTS.BASE.EMERGENCY_LEVEL.",
    };
  },
  computed: {
    emergencyLevelTitle() {
      return this.I18nPrefix + "LEVEL" + this.level;
    },
  },
};
</script>
